export default __webpack_public_path__ + "img/favicon.e405ca11b8a36741daba227f9a2cdb06.png";